<script setup lang="ts">
import HowItWorksSlider from './HowItWorksSlider.vue'
</script>

<template>
  <section
    id="how-it-works-section"
    class="flex h-lvh flex-col items-center justify-start gap-8 border-t px-8 py-12 text-center sm:p-32 dark:border-gray-700"
  >
    <ClientOnly>
      <HowItWorksSlider />
    </ClientOnly>
  </section>
</template>

<style scoped>
  #how-it-works-section {
    perspective: 1500px;
    transform-style: preserve-3d;
  }
</style>
